import { forwardRef } from "react";
import { NumericFormat } from "react-number-format";
import PropTypes from 'prop-types';

const TrialField = forwardRef(
  function NumberField(props, ref) {
    const { onChange, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        valueIsNumericString={true}
        allowNegative={false}
        decimalScale={0}
        thousandsGroupStyle={''}
        isAllowed={(values) => (values.floatValue < 366) || (values.value === '')}
        onValueChange={(values) => {
          onChange(values.floatValue);
        }}
      />
    );
  }
);

TrialField.propTypes = {
  onChange: PropTypes.func.isRequired
};

export default TrialField;